import React, { FunctionComponent, useContext, useEffect, useRef, useState } from 'react';
import { Loader } from '@googlemaps/js-api-loader';
import { BikeRelay40YearsPoint } from './types';
import { bikeRelay40YearsCreateMapElements } from './utils/bike-relay-utils';
import { BikeRelay40YearsContext } from './context/bike-relay-40-years-context';

interface Props {
  center: { lat: number; lng: number };
  zoom: number;
  mapOptions?: google.maps.MapOptions;
  relayPoints: BikeRelay40YearsPoint[];
  apiKey: string;
}

const BikeRelay40YearsGoogleMap: FunctionComponent<Props> = ({
  center,
  zoom,
  mapOptions,
  relayPoints,
  apiKey
}) => {
  const { currentRelayPoint } = useContext(BikeRelay40YearsContext);

  const mapRef = useRef<HTMLDivElement>(null);
  const [map, setMap] = useState<google.maps.Map | null>(null);

  useEffect(() => {
    const loader = new Loader({
      apiKey: apiKey,
      version: 'weekly',
      libraries: ['places', 'marker']
    });

    loader
      .load()
      .then(() => {
        if (!mapRef.current) {
          throw new Error('Map ref is not set');
        }
        const newMap = new google.maps.Map(mapRef.current, {
          center,
          zoom,
          mapId: '40-jaar',
          ...mapOptions
        });
        setMap(newMap);
      })
      .catch((e: unknown) => {
        console.error('Error loading Google Maps API:', e);
      });

    return () => {
      if (map) {
        setMap(null);
      }
    };
  }, []);

  useEffect(() => {
    if (map) {
      bikeRelay40YearsCreateMapElements(relayPoints, map);
      //const currentRelayPoint = relayPoints.find((point) => point.isCurrent);
      //console.log('currentRelayPoint', currentRelayPoint);
      map.setCenter({
        lat: currentRelayPoint?.at(0)?.latitude || 0,
        lng: currentRelayPoint?.at(0)?.longitude || 0
      });
      map.setZoom(zoom);
    }
  }, [map]);
  return <div ref={mapRef} style={{ height: '600px', width: '100%' }} />;
};

export default BikeRelay40YearsGoogleMap;
